module.exports = __webpack_public_path__ + "static/media/acura-muti-parking-selected.931bb525.svg";